import { Route, Router, Routes, Navigate } from 'react-router-dom';
//import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './login/LoginPage';
import Home from './Home/MyHome';
import NocForm from './NOC/NocForm';
import EmpDetailsForm from './NOC/EmpDetailsForm';
import DraftNoc from './NOC/DraftNoc';
import ApproveNoc from './NOC/ApproveNoc';
import ApprovedList from './NOC/ApprovedList';
import Dashboard from './NOC/Dashboard';

export default function Routing() {


    return (
        <Routes>
            <Route path="/" element={<Navigate to="/my-login" />} />
            <Route path="/my-login" element={<LoginPage />} />
            <Route path="/pending" element={<ApproveNoc />} />
            <Route path="/approved" element={<ApprovedList />} />
            <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
    )

}
